// extracted by mini-css-extract-plugin
export default {"sidebarIcon":"AOhOKmFE svg svg-small","titleIcon":"T4M9cA1T svg svg-small","titleBtn":"GQNHmbMv","buttonGroup":"brnlgCLF"};